<template>

    <v-section>

        <div class="row">
            <div :class="imageSide === 'r' ? 'col-md-6 d-block d-md-none' : 'col-md-6'">
                <img class="screen" :src="image" />
            </div>
            <div class="col-md-6">
                <i class="icon" :class="icon"></i>
                <h5 v-if="subtitle">{{ subtitle }}</h5>
                <h4>{{ title }}</h4>
                <p class="mb-30">{{ headline }}</p>
                <v-button size="md" @click.native="$router.push({ 'name': slug })">
                    <span><i class="fa-solid fa-circle-play mr-10"></i>Learn More</span>
                </v-button>
                <div v-if="testimonial" class="testimonial">
                    <img class="photo mb-10" :src="testimonial.photo" />
                    <div>
                        <div class="quote mb-10" v-html="'&ldquo;' + testimonial.quote + '&rdquo;'" />
                        <div class="name">{{ testimonial.name }}, {{ testimonial.title }} at <a :href="testimonial.link" target="_blank">{{ testimonial.company }}</a></div>
                    </div>
                </div>
            </div>
            <div v-if="imageSide === 'r'" class="col-md-6 d-none d-md-block">
                <img class="screen" :src="image" />
            </div>
        </div>

    </v-section>

</template>

<style scoped lang="scss">

    .section {
        background: linear-gradient(0deg, $color-bg 0%, #fff 100%);
        text-align: left;
        .row {
            align-items: center;
        }
        .screen {
            height: auto;
            width: 100%;
        }
        .icon {
            color: $color-primary;
            font-size: 20px;
            margin-bottom: 15px;
        }
        .testimonial {
            @include font-medium(15px);
            align-items: top;
            border-top: 1px solid $color-rule;
            display: flex;
            line-height: 1.6em;
            margin-top: 30px;
            padding-top: 30px;
            .photo {
                border-radius: 30px;
                height: 60px;
                margin-right: 15px;
                width: 60px;
            }
            .quote {
                font-style: italic;
            }
        }
        @media (max-width: map-get($grid-breakpoints, 'md')) {
            text-align: center;
            .screen {
                margin-bottom: 30px;
            }
            .btn {
                margin: 0 auto;
            }
            .testimonial {
                align-items: center;
                border: none;
                flex-direction: column;
                font-size: 14px;
                padding: 0;
                .photo {
                    margin-right: 0;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        icon: {
            type: String,
            default: 'icon-campaign',
        },
        image: {
            type: String,
            required: true,
        },
        imageSide: {
            type: String,
            default: 'l',
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
        },
        headline: {
            type: String,
            required: true,
        },
        slug: {
            type: String,
            default: 'user-management',
        },
        testimonial: {
            type: Object,
        },
    },

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
        }
    },

    methods: {

        signup() {
            window.location.href = this.appUrl + '/signup';
        },

    },

}

</script>